module.exports = __webpack_public_path__ + "img/columns.40b14c4c.svg";